import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InnovationComponent } from './innovation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: InnovationComponent,
    data: {
      title: "Innovation",
      breadcrumb: "Innovation"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class InnovationRoutingModule { }